module.exports = __webpack_public_path__ + "img/Ellipse2.882dde77.png";